module.exports = __webpack_public_path__ + "img/undraw_global.4b1a5dcf.png";